<div class="expiration">
  <p>{{ 'cash-Expiration' | translation | async }} </p>
  <p class="date">
    <fa-icon [icon]="['far', 'calendar-alt']" size="X2"></fa-icon>
    {{ expiration }}
  </p>
</div>
